import { NgModule } from "@angular/core";
import { IMPORTS, DECLARATIONS } from ".";

@NgModule({
  declarations: [...DECLARATIONS],
  imports: [...IMPORTS],
})
export class ReportsModule {}
